<template>
    <footer class="footer">
        <div class="footer-content">
            <p>© 2025 Inovare. All rights reserved.</p>
            <div class="footer-links">
                <router-link to="/">Home</router-link>
                <router-link to="/contact">Contact</router-link>
                <router-link to="/about">About</router-link>
                <router-link to="/meet-the-team">Meet The Team</router-link>
                <router-link to="/events">Events</router-link>
                <router-link to="/privacy">Privacy Policy</router-link>
            </div>
            <p style="font-size: 0.7rem; opacity: 0.6;">Empowering Innovation • Connecting Minds • Building Future</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: "AppFooter",
}
</script>

<style scoped>
.footer {
    bottom: 0;
    position: relative;
    width: 100%;
}
</style>